import { createFileRoute } from '@tanstack/react-router'
import { Template } from '@/components/settings-route/other/template/index.jsx'

export const Route = createFileRoute('/_auth/settings/others/templates')({
  component: Template,
})
